import { Coin } from '@phosphor-icons/react';

export default Coin;